export default {
  bannerServiceDesignData: {
    es: [
      {
        name: 'service-design',
        imageBanner: '',
        imageDesktopXL: '/assets/images/service-design/insurance.webp',
        imageDesktop: '/assets/images/service-design/insurance.webp',
        imageMobile: '/assets/images/service-design/insurance.webp',
        altImage: 'Diseño del servicio',
        text1: 'Service Design',
        text2: 'Seguro Salud',
        text3: '',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
    en: [
      {
        name: 'service-design',
        imageBanner: '',
        imageDesktopXL: '/assets/images/service-design/insurance.webp',
        imageDesktop: '/assets/images/service-design/insurance.webp',
        imageMobile: '/assets/images/service-design/insurance.webp',
        altImage: 'Diseño del servicio',
        text1: 'Service Design',
        text2: 'Health insurance',
        text3: '',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
  },
};
